import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0cd918cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd918cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd918cc')) {
      api.createRecord('0cd918cc', component.options)
    } else {
      api.reload('0cd918cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0cd918cc&scoped=true", function () {
      api.rerender('0cd918cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkLocation/index.vue"
export default component.exports